import { TablePagination } from '@acast-tech/decibel';
import { useState } from 'react';

const calcNumberOfPages = (numberOfItems: number, pageSize: number) =>
  Math.max(1, Math.ceil(numberOfItems / pageSize));

const clampPage = (page: number, numberOfPages: number) =>
  Math.max(1, Math.min(numberOfPages, page));

function PaginatedList<TData>({
  data,
  renderItem,
}: {
  data: TData[];
  renderItem: (item: TData) => JSX.Element;
}) {
  const numberOfItems = data.length;

  const pagination = {
    summary: true,
    pageSizeOptions: [10, 25, 50],
    defaultPageSize: 10,
  };

  const [pageSize, setPageSize] = useState(pagination.defaultPageSize);
  const [unclampedPage, setPage] = useState(1);

  if (numberOfItems === 0) {
    return <span className="text-textGrey text-center text-lg">No data</span>;
  }

  const numberOfPages = calcNumberOfPages(numberOfItems, pageSize);
  const page = clampPage(unclampedPage, numberOfPages);
  const pageStart = (page - 1) * pageSize;
  const pageEnd = Math.min(pageStart + pageSize, numberOfItems);

  const currentPageItems = data.slice(pageStart, pageEnd);

  return (
    <>
      <ul>
        {currentPageItems.map((item: TData, i) => (
          <li key={`list-item-${i}`}>{renderItem(item)}</li>
        ))}
      </ul>
      {numberOfItems > pagination.defaultPageSize && (
        <TablePagination
          total={numberOfItems}
          current={page}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          pageSizeOptions={pagination.pageSizeOptions}
        />
      )}
    </>
  );
}

export default PaginatedList;
